<fc-signup-completed
    [error]="error$ | async"
    [redirectToLogin]="redirectToLoginAfterError$ | async"
    (actionButtonClicked)="retry()"
></fc-signup-completed>
